import { createContext } from "react";

const carBrandContext = createContext();

export default carBrandContext;